import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableBody, TableHead, TableCell } from '@material-ui/core';

import { Content } from 'api';
import { ResponsiveTable } from 'components';
import { ContentProvider } from 'providers';
import { ShareButton } from 'features/content/widgets';

import DateCell from './Cells/Date';
import ImageCell from './Cells/Image';
import PostCell from './Cells/Post';
import StatCell from './Cells/Stat';
import { RowHead, RowBody } from './TableRow';

interface IProps {
  results: Content[];
}

const ShareThese: FC<IProps> = ({ results }) => {
  const { t } = useTranslation();

  return (
    <ResponsiveTable>
      <Table>
        <TableHead>
          <RowHead>
            <TableCell colSpan={3} size="small">
              {t('sharing:postedOn')}
            </TableCell>
            <TableCell size="small">{t('common:share_plural')}</TableCell>
            <TableCell size="small">{t('common:click_plural')}</TableCell>
            <TableCell size="small">{t('common:engagement_plural')}</TableCell>
            <TableCell />
          </RowHead>
        </TableHead>
        <TableBody>
          {results.map(content => (
            <RowBody key={content.content_id}>
              <DateCell time={content.publish_at} />
              <ImageCell content={content} />
              <PostCell content={content} />
              <StatCell value={content.share_count} />
              <StatCell value={content.click_count} />
              <StatCell value={content.engagement_count} />
              <TableCell>
                <ContentProvider value={{ content }}>
                  <ShareButton size="small" />
                </ContentProvider>
              </TableCell>
            </RowBody>
          ))}
        </TableBody>
      </Table>
    </ResponsiveTable>
  );
};

export default ShareThese;
